<template>
    <apex-chart type="line" :height="300" :options="chartOptions" :series="seriesData" />
</template>
<script>
export default {
    props: ['series', 'title', 'unit', 'type', 'legend'],
    computed: {
        seriesData() {
            return this.series.map(item => ({
                name: item.name,
                data: item.data.map(data => data.value ?? 0)
            }));
        },
        chartOptions() {
            return {
                chart: {
                    id: this.title,
                    toolbar: {
                        tools: {
                            selection: false,
                            zoom: false,
                            zoomin: false,
                            zoomout: false,
                            reset: false,
                            pan: false
                        }
                    }
                },
                title: {
                    text: this.title
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth',
                    width: 2
                },
                annotations: {
                    yaxis: this.legend ? this.legend.map(item => ({
                        y: item.value,
                        borderColor: item.color,
                        label: {
                            show: true,
                            text: item.name,
                            position: 'left',
                            offsetX: 34,
                            style: {
                                color: "#fff",
                                background: item.color
                            }
                        }
                    })) : []
                },
                tooltip: {
                    y: {
                        formatter: value => {
                            return value + this.unit;
                        }
                    },
                },
                yaxis: {
                    showDuplicates: false,
                    min: 0,
                    max: Math.max(...this.series.flatMap(item => item.data.map(data => data.value ?? 0))) * 1.2,
                    forceNiceScale: true,
                    labels: {
                        formatter: value => value.toFixed(0)
                    }
                },
                xaxis: {
                    categories:
                        this.series.length > 0 ? this.series[0].data.map(item => item.label) : [],
                    labels: {
                        hideOverlappingLabels: true,
                        rotate: -45,
                        rotateAlways: true,
                    }
                }
            };
        }
    },
    methods: {
        getTooltipX(value) {
            if (this.type === 'byHour') return `${value} giờ`;
            if (this.type === 'byDay') {
                if (value === 'CN') return 'Chủ nhật';
                return value.toString().replace('T', 'Thứ ');
            }
            return value;
        }
    }
};
</script>
